import { createAuthedHttpClient } from '@driftt/web-auth'
import axios from 'axios'
import Qs from 'qs'

import config from 'config'

axios.defaults.headers.post['Content-Type'] = 'application/json'

export const ReachAPI = createAuthedHttpClient({
  baseConfig: { baseURL: config.REACH_API },
})

export const ReviewAPI = createAuthedHttpClient({
  baseConfig: { baseURL: config.REVIEW_API },
})

export const CustomerAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CUSTOMER_API,
    paramsSerializer: (params) =>
      Qs.stringify(params, { arrayFormat: 'repeat' }),
  },
})

export const ConversationAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CONVERSATION_API,
    paramsSerializer: (params) =>
      Qs.stringify(params, { arrayFormat: 'repeat' }),
  },
})

export const ConversationAPIWithOrgHeaders = (orgId: number) =>
  createAuthedHttpClient({
    baseConfig: {
      baseURL: config.CONVERSATION_API,
      headers: {
        'X-Drift-OrgId': orgId,
        'Content-Type': 'multipart/form-data',
      },
      paramsSerializer: (params) =>
        Qs.stringify(params, { arrayFormat: 'repeat' }),
    },
  })

export const PagesAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.PAGES_API,
  },
})

export const FileAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.FILE_API,
    paramsSerializer: (params) =>
      Qs.stringify(params, { arrayFormat: 'repeat' }),
  },
})

export const SyncjobAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.SYNCJOB_API,
    paramsSerializer: (params) =>
      Qs.stringify(params, { arrayFormat: 'repeat' }),
  },
})

export const FlowAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.FLOW_API,
  },
})

export const MeetingsAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.MEETINGS_API,
    paramsSerializer: (params) =>
      Qs.stringify(params, { arrayFormat: 'repeat' }),
  },
})

export const TargetingAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.TARGETING_API,
  },
})

export const FalcorAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.FALCOR_API,
  },
})

export const WorkspaceAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.WORKSPACE_API,
  },
})

export const ReportAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.REPORT_API,
  },
})

export const TopicTrainingAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.TOPIC_TRAINING_API,
  },
})

export const InsightsAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.INSIGHTS_API,
  },
})

export const AiPlatformAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.AI_PLATFORM_API,
  },
})

export const ReuseApi = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.PLAYBOOK_REUSABILITY_API,
    paramsSerializer: (params) =>
      Qs.stringify(params, { arrayFormat: 'repeat' }),
  },
})

export const FormAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.FORM_API,
  },
})
